/**
 * Moved to `shared/src/review/serp-intent-highlight.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  buildSerpContractTermSegments,
  buildYourPageVocabularySegments,
  collectMisalignedPhraseLinks,
  foldLexicalToken
} from '@taptimize/shared/dist/review/serp-intent-highlight';
export type {
  MisalignedPhraseLink,
  SerpCollocationHead
} from '@taptimize/shared/dist/review/serp-intent-highlight';
